import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import styles from '../../Toasts.module.scss';

const ToastContent = ({ title, details, onClick }) => (
  <div onClick={onClick}>
    <div className={styles.title}>{title}</div>
    {details && <div className={styles.details}>{details}</div>}
  </div>
);

ToastContent.propTypes = {
  title: PropTypes.string.isRequired,
  details: PropTypes.string,
  onClick: PropTypes.func,
};

ToastContent.defaultProps = {
  onClick: noop,
};

export default ToastContent;
